<template>
  <BDLayout>
    <div class="bd-fade-in bd-card-lift">
      <h3>Contract Milestones</h3>
      <div v-if="loading">Loading...</div>
      <div v-else>
        <div class="contract-summary">
          <p><strong>Contract:</strong> {{ contract?.opportunity?.tenderTitle || contract?.id }}</p>
          <p><strong>Award Date:</strong> {{ formatDate(contract?.awardDate) }}</p>
          <p><strong>Value:</strong> {{ formatCurrency(contract?.contractValue) }}</p>
        </div>

        <h4>Milestones</h4>
        <table class="milestones-table">
          <thead>
            <tr><th>#</th><th>Name</th><th>Due Date</th><th>Amount</th><th>Status</th></tr>
          </thead>
          <tbody>
            <tr v-for="(m, i) in contract?.milestones || []" :key="m.id">
              <td>{{ i + 1 }}</td>
              <td>{{ m.name }}</td>
              <td>{{ formatDate(m.dueDate) }}</td>
              <td>{{ formatCurrency(m.amount) }}</td>
              <td>{{ m.status }}</td>
            </tr>
            <tr v-if="(contract?.milestones || []).length === 0"><td colspan="5">No milestones</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </BDLayout>
</template>

<script>
import bidApi from '@/api/bid'
import BDLayout from '@/components/BDLayout.vue'
export default {
  name: 'ContractDetail',
  components: { BDLayout },
  data() {
    return {
      contract: null,
      loading: true,
    }
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const id = this.$route.params.id
        const res = await bidApi.listContracts({ id })
        // backend /contracts/:id returns single object; our listContracts returns array
        if (Array.isArray(res)) {
          this.contract = res.length ? res[0] : null
        } else if (res && res.data && Array.isArray(res.data) && res.data.length) {
          this.contract = res.data[0]
        } else {
          // try fetch single endpoint
          const single = await bidApi.getContract ? bidApi.getContract(id) : null
          this.contract = single || null
        }
      } catch (e) {
        console.error('Failed to load contract', e)
        this.contract = null
      } finally {
        this.loading = false
      }
    },
    formatDate(d) { if (!d) return '-'; try { return new Date(d).toLocaleDateString() } catch (e) { return d } },
    formatCurrency(v) { if (v === undefined || v === null) return '-'; return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(v) },
  },
  mounted() { this.load() },
}
</script>

<style scoped>
.milestones-table { width: 100%; border-collapse: collapse }
.milestones-table th, .milestones-table td { padding: 8px; border-bottom: 1px solid #eee }
.contract-summary { margin-bottom: 1rem }
</style>
